import { IPublicClientApplication } from "@azure/msal-browser";
import {
    axiosDelRequest,
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequest,
} from "../../api/ApiClient";
import AgendaDTO from "../../model/dto/AgendaDTO";
import AgendaSalvarDTO from "../../model/dto/AgendaSalvarDTO";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/agendas";

function getSchedule(
    dataInicial: string,
    dataFinal: string,
    matriculaAdp: string,
    instance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        data_inicial: dataInicial,
        data_final: dataFinal,
        matricula_adp: matriculaAdp,
    });

    return axiosGetRequest(
        `${route}${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function getScheduleBacklogs(
    dataInicial: string,
    dataFinal: string,
    matricula: string,
    instance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        data_inicial: dataInicial,
        data_final: dataFinal,
        matricula,
    });

    return axiosGetRequest(
        `${route}/backlogs${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function getSporadicActivities(
    matriculaAdp: string,
    dataLimite: string,
    instance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        "matricula-adp": matriculaAdp,
        "data-limite": dataLimite,
    });

    return axiosGetRequest(
        `${route}/atividades-esporadicas${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function saveSchedule(
    agendaSalvarDTO: AgendaSalvarDTO,
    instance: IPublicClientApplication
) {
    return axiosPostRequest(
        `${route}`,
        agendaSalvarDTO,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function editCard(agendaDTO: AgendaDTO, instance: IPublicClientApplication) {
    return axiosPutRequest(
        `${route}/${agendaDTO.cartaoAgendaId}`,
        agendaDTO,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function deleteCardIntrajornada(
    cartaoAgendaId: number,
    instance: IPublicClientApplication
) {
    return axiosDelRequest(
        `${route}/${cartaoAgendaId}/cartao-intrajornada`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getSchedule,
    getScheduleBacklogs,
    getSporadicActivities,
    saveSchedule,
    editCard,
    deleteCardIntrajornada,
};
